import { api } from '@/helpers/interceptors'

import {
  REPORT_STOCK_CHECKED,
  REPORT_ACTIVITY_LOG,
  REPORT_CHECKED_BY_DATE,
  REPORT_JOB_RESULT,
  REPORT_STOCK_ACTIVITY_BY_DATE,
  REPORT_STOCK_PROGRESS,
  REPORT_STOCK_PROGRESS_BY_DATE,
  REPORT_EMPLOYEES_NOT_CHECKED_STOCK,
} from '@/constants/path'

const state = () => ({
  isError: false,
  isLoading: false,
})

// getters
const getters = {}

// actions
const actions = {
  async stockChecked({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    let bodyFormData = new FormData()
    try {
      if (payload?.job_id) {
        bodyFormData.append('job_id', payload?.job_id)
      }
      if (payload?.store_id) {
        bodyFormData.append('store_id', payload?.store_id)
      }
      if (payload?.filter_status) {
        bodyFormData.append('filter_status', payload?.filter_status)
      }
      const res = await api(
        REPORT_STOCK_CHECKED,
        'post',
        bodyFormData,
      )

      commit('success/SET_MESSAGE', res?.data?.data, { root: true })
      commit('success/SET_TOAST', true, { root: true })
      commit('SET_LOADING', false)

      // TODO: Deprecated for send email
      // FileDownload(res.data, `report_${payload.name}.csv`)
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async activityLog({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    let bodyFormData = new FormData()
    try {
      if (payload?.job_id) {
        bodyFormData.append('job_id', payload?.job_id)
      }
      if (payload?.store_id) {
        bodyFormData.append('store_id', payload?.store_id)
      }
      if (payload?.filter_status) {
        bodyFormData.append('filter_status', payload?.filter_status)
      }
      const res = await api(REPORT_ACTIVITY_LOG, 'post', bodyFormData)

      commit('success/SET_MESSAGE', res?.data?.data, { root: true })
      commit('success/SET_TOAST', true, { root: true })
      commit('SET_LOADING', false)

      // TODO: Deprecated for send email
      // FileDownload(res.data, `report_${payload.name}.csv`)
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async checkedByDate({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    let bodyFormData = new FormData()
    try {
      if (payload?.start_date) {
        bodyFormData.append('start_date', payload?.start_date)
      }
      if (payload?.end_date) {
        bodyFormData.append('end_date', payload?.end_date)
      }
      if (payload?.bu_id) {
        payload?.bu_id?.forEach((item) => {
          bodyFormData.append('bu_ids[]', item)
        })
      }
      if (payload?.filter_status) {
        bodyFormData.append('filter_status', payload?.filter_status)
      }
      const res = await api(
        REPORT_CHECKED_BY_DATE,
        'post',
        bodyFormData,
      )

      commit('success/SET_MESSAGE', res?.data?.data, { root: true })
      commit('success/SET_TOAST', true, { root: true })
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async stockActivityByDate({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    let bodyFormData = new FormData()
    try {
      if (payload?.start_date) {
        bodyFormData.append('start_date', payload?.start_date)
      }
      if (payload?.end_date) {
        bodyFormData.append('end_date', payload?.end_date)
      }
      if (payload?.bu_id) {
        bodyFormData.append('bu_id', payload?.bu_id)
      }
      if (payload?.filter_status) {
        bodyFormData.append('filter_status', payload?.filter_status)
      }
      const res = await api(
        REPORT_STOCK_ACTIVITY_BY_DATE,
        'post',
        bodyFormData,
      )

      commit('success/SET_MESSAGE', res?.data?.data, { root: true })
      commit('success/SET_TOAST', true, { root: true })
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async stockProgressByDate({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    let bodyFormData = new FormData()
    try {
      if (payload?.start_date) {
        bodyFormData.append('start_date', payload?.start_date)
      }
      if (payload?.end_date) {
        bodyFormData.append('end_date', payload?.end_date)
      }
      if (payload?.bu_id) {
        bodyFormData.append('bu_id', payload?.bu_id)
      }
      const res = await api(
        REPORT_STOCK_PROGRESS_BY_DATE,
        'post',
        bodyFormData,
      )

      commit('success/SET_MESSAGE', res?.data?.data, { root: true })
      commit('success/SET_TOAST', true, { root: true })
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async employeesNotCheckedStock({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    let bodyFormData = new FormData()
    try {
      if (payload?.job_id) {
        bodyFormData.append('job_id', payload?.job_id)
      }
      if (payload?.store_id) {
        bodyFormData.append('store_id', payload?.store_id)
      }
      const res = await api(
        REPORT_EMPLOYEES_NOT_CHECKED_STOCK,
        'post',
        bodyFormData,
      )

      commit('success/SET_MESSAGE', res?.data?.data, { root: true })
      commit('success/SET_TOAST', true, { root: true })
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async stockProgress({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    let bodyFormData = new FormData()
    try {
      if (payload?.job_id) {
        bodyFormData.append('job_id', payload?.job_id)
      }
      if (payload?.store_id) {
        bodyFormData.append('store_id', payload?.store_id)
      }
      const res = await api(
        REPORT_STOCK_PROGRESS,
        'post',
        bodyFormData,
      )

      commit('success/SET_MESSAGE', res?.data?.data, { root: true })
      commit('success/SET_TOAST', true, { root: true })
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
  async jobResult({ commit }, payload) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', false)
    let bodyFormData = new FormData()
    try {
      if (payload?.job_id) {
        bodyFormData.append('job_id', payload?.job_id)
      }
      if (payload?.filter_status) {
        bodyFormData.append('filter_status', payload?.filter_status)
      }
      const res = await api(REPORT_JOB_RESULT, 'post', bodyFormData)

      commit('success/SET_MESSAGE', res?.data?.data, { root: true })
      commit('success/SET_TOAST', true, { root: true })
      commit('SET_LOADING', false)
    } catch (error) {
      commit('SET_LOADING', false)
      commit('SET_ERROR', true)

      throw error
    }
  },
}

// mutations
const mutations = {
  SET_ERROR(state, payload) {
    state.isError = payload
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
